import React from "react";
import { useLocation } from "react-router-dom";

import { scrollToSection } from "../../utils/generalUtils";

//Scrolls to the #section when the site is opened with one (e.g. /services#mentorship), otherwise to the top
const ScrollToHash = () => {
  const { pathname, hash } = useLocation();

  React.useEffect(() => {
    if (hash) {
      //Wait for the page to render the target
      const timeout = window.setTimeout(() => scrollToSection(hash.slice(1)), 100);
      return () => window.clearTimeout(timeout);
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    return undefined;
  }, [pathname]);

  return null;
};

export default ScrollToHash;
